import $ from 'jquery';

window.$ = window.jQuery = $;
window.$ = window.jQuery = $.noConflict();

export class FancyHash {
    constructor() {

        document.addEventListener('DOMContentLoaded', function () {
            var fancyboxHash = window.location.hash;
            if (fancyboxHash) {
                $(`[data-fancybox-hash="${fancyboxHash}"]`)[0].trigger('click');
            }
        });


    }
}